import {
  RollEntriesInput,
  useSaveWeekSessionsMutation,
  useSetRollEntriesMutation,
  WeekSessionsInput,
} from "../../../../../generated/graphql";

// Changes to the roll of a class are sent one at a time (e.g. when quickly ticking several
// students) so that each change is based on the result of the previous one.
const classQueues = new Map<number, Promise<unknown>>();

const enqueue = <T>(classId: number, task: () => Promise<T>): Promise<T> => {
  const previous = classQueues.get(classId) ?? Promise.resolve();
  const result = previous.then(task, task);
  classQueues.set(
    classId,
    result.catch(() => undefined)
  );
  return result;
};

const useRollMutations = (): {
  setRollEntries: (input: RollEntriesInput) => Promise<void>;
  saveWeekSessions: (input: WeekSessionsInput) => Promise<void>;
} => {
  const [setRollEntriesMutation] = useSetRollEntriesMutation();
  const [saveWeekSessionsMutation] = useSaveWeekSessionsMutation();

  return {
    saveWeekSessions: (input) =>
      enqueue(input.classId, async () => {
        await saveWeekSessionsMutation({ variables: { input } });
      }),
    setRollEntries: (input) =>
      enqueue(input.classId, async () => {
        await setRollEntriesMutation({ variables: { input } });
      }),
  };
};

export default useRollMutations;
